import { useEffect, useState } from "react";
import api from "../../../../../../features/auth/axiosConfig";

export function useOrder(orderId?: string) {
  const [order, setOrder] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!orderId) return;
    setLoading(true);
    api.get(`/app/v1/pos/order/${orderId}`)
      .then(res => setOrder(res.data.result))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, [orderId]);

  return { order, loading };
}
